module.exports = __webpack_public_path__ + "static/media/MovingApp_android_3_preview.9d789f00.jpg";